// extracted by mini-css-extract-plugin
export default {"toolbar":"Toolbar_toolbar__S2ZMj","spacer":"Toolbar_spacer__0dz8y"};